export const NEXT_PUBLIC_ENV_KEYS = [
  'NEXT_PUBLIC_UAT_AUTH_TOKEN',
  'APOLLOGRAPHQL_ACTIVE_IN_AEM_PREVIEW',
  'SESSION_GET_CALL_URL_CLIENT',
  'NEXT_PUBLIC_SUBMIT_SEARCH_URL',
  'NEXT_PUBLIC_AVAILABILITY_SEARCH_URL',
];

export const LOCALE_SUBDIRECTORY_MAPPING: Record<string, string> = {
  'it-IT': '/it',
  'ru-RU': '/ru',
  'en-GB': '/en-gb',
  'ko-KR': '/ko',
  'en-US': '/en-us',
  'pt-BR': '/pt-br',
  'zh-CN': '/cn',
  'fr-FR': '/fr',
  'ja-JP': '/ja',
  'de-DE': '/de',
  'pt-PT': '/pt',
  'es-ES': '/es',
  'nl-NL': '/nl',
  'pl-PL': '/pl-pl',
  'tr-TR': '/tr-tr',
  'da-DK': '/da',
  'sv-SE': '/sv',
  'el-GR': '/el',
  'th-TH': '/th',
  'fi-FI': '/fi',
  'nb-NO': '/no',
  'ar-AE': '/ar',
};

export const FR_LOCALE = 'fr-FR';
export const ES_LOCALE = 'es-ES';
export const PT_BR_LOCALE = 'pt-BR';
export const KR_LOCALE = 'ko-KR';
export const RU_LOCALE = 'ru-RU';
export const DE_LOCALE = 'de-DE';

export const BREAKPOINT_TABLET = 767;
export const BREAKPOINT_DESKTOP = 991;
export const RECENT_SEARCH_LIST_LIMIT = 5;
export const croppingRatio = 6;
export const outputQuality = 90;
export const outputInterpolation = 'progressive-bilinear';
export const SURCHARGE_ORDINANCE_CODE = 'surchargeOrdinanceCostDescription';
export const RESORT_FEE_CODE = 'resortFeeDescription';
export const DESTINATION_FEE_CODE = 'destinationFeeDescription';
export const DESTINATION_FEE_CODE_DESCRIPTION = 'DESTINATION FEE DESCRIPTION';
export const DAILY_TEXT = 'Daily ';
export const FEEDESCRIPTION_RESORT = 'Resort Fee';
export const DAILY_RESORT_FEE_LABEL = 'Daily Resort Fee';
export const RESORT_LABEL = 'Resort';
export const FEEDESCRIPTION_DESTINATION = 'Destination Amenity Fee';
export const DAILY_DESTINATION_FEE_LABEL = 'Daily Destination Fee';
export const DAILY_TOURISM_MARKETING_FEE_LABEL = 'Daily Tourism Marketing Fee';
export const DESTINATION_AMENITY_LABEL = 'Destination Amenity';
export const FEE_LABEL = 'fee';
export const MANDATORYFEE_TITLE = 'Surcharge for Ordinance Cost';
export const SURCHARGE_MANDATORY_FEE_LABEL = 'Surcharge for Ordinance Cost';
export const FEEDESCRIPTION1 = 'Includes';
export const INCLUDES_LABEL = 'Includes';
export const FEEDESCRIPTION2 = 'Surcharge for Ordinance Cost';
export const VIEW_RATE_LABEL = 'View Rates';
export const INTERNAL_CTA_TYPE = 'Internal';
export const EXTERNAL_CTA_TYPE = 'External';
export const BREADCRUMB_ALIGNMENT = 'horizontal-align';
export const MILES_TO_METERS = 1609.344;
export const PARAM_PAGENO = 'pg';
export const KILOMETERS_TO_MILES = 0.621371;
export const MARRIOTT_CACHE_URL = 'https://cache.marriott.com/';
// convert meters distance to miles
export const METERSTOMILES = 1609.344;
//convert miles distance to km
export const METERSTOKM = 1000;
export const HOTEL_VIEW = 'hotelView';
export const HOTEL_MARKETING_CAPTION = 'HOTEL_MARKETING_CAPTION';
export const RESORT_FEE_DESCRIPTION = 'RESORT_FEE_DESCRIPTION';
export const SURCHARGE_ORDINANCE_COST_DESCRIPTION = 'SURCHARGE_ORDINANCE_COST_DESCRIPTION';
export const DESTINATION_FEE_DESCRIPTION = 'DESTINATION_FEE_DESCRIPTION';
export const TOURISM_MARKETING_FEE_DESCRIPTION = 'TOURISM_MARKETING_FEE_DESCRIPTION';
export const WARN_SEARCH_1009 = 'WARN-SEARCH-1009';
